import type { ScenarioDefinition } from "../../domain/types";
import "./ScenarioSelector.css";

export interface ScenarioSelectorProps {
  scenarios: ScenarioDefinition[];
  selectedId: string;
  onSelect: (id: string) => void;
}

/**
 * Selector de escenario. Usa <fieldset>/<legend> y radios nativos: navegación con
 * flechas y anuncio de grupo los da el navegador sin roles ARIA adicionales.
 */
export function ScenarioSelector({ scenarios, selectedId, onSelect }: ScenarioSelectorProps) {
  return (
    <fieldset className="scenario-selector">
      <legend>Elige un escenario</legend>
      <div className="scenario-selector__list">
        {scenarios.map((scenario) => (
          <label key={scenario.id} className="scenario-selector__option">
            <input
              type="radio"
              name="scenario"
              value={scenario.id}
              checked={selectedId === scenario.id}
              onChange={() => onSelect(scenario.id)}
            />
            <span>
              <span className="scenario-selector__title">{scenario.title}</span>{" "}
              <span className="scenario-selector__description">{scenario.description}</span>
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
